import { NEW_LINES_REG_EXP } from '../../constants/regex.constants';

export const capitalizeFirstLetter = (str: string): string => {
    const SPACE_SEPARATOR = ' ';

    return str
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(SPACE_SEPARATOR)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(SPACE_SEPARATOR);
};

export const replaceNewLinesWithSpace = (str: string): string => {
    return str.replace(NEW_LINES_REG_EXP, ' ');
};
